import React from "react";
import { tx } from "../../../lib/ddd/ddd";
import classes from "../../technicalOverviewComponents/techOverview.module.scss";
import arrowIcon from "../../../assets/arrow.svg";
import { Collapse } from "react-bootstrap";
import SchemaImg from "../../technicalOverviewComponents/schema.webp";
import { Tooltip, OverlayTrigger } from "react-bootstrap";

const IntroFull = ({}) => {
  const tooltip = (
    <Tooltip id={`tooltip-introduction`}>
      Set up the steps that will be executed on the invoice data (generate PDF,
      fiscalization, generate e-invoice, send to domestic tax authority, send
      internationally etc.) and choose what documents you want to get in the
      response of the {tx("DDDI_Save")} API call (PDF, e-invoice, PEPPOL e-invoice
      etc.). For your domestic country's default settings, choose step 999.
    </Tooltip>
  );

  return (
    <>
        <div id="intro-collapse-text">
          <p>
            Integration with the DDD Invoices service can be made in three
            simple steps.
          </p>
          <div class="d-flex flex-column flex-md-row gap-1 mb-3">
            <div style={{ flex: 1 }}>
              <ol class="workflow-steps">
                <li>
                  Call the {tx("DDDI_GetNew")} API to retrieve the initialized invoice
                  JSON object. This API will provide you with an invoice object
                  that is ready to be populated with data.
                </li>
                <li>
                  Fill the invoice object with the necessary data from your
                  software.
                </li>
                <ul>
                  <li>
                    Choose the steps that should get executed on the invoice
                    data, as well as the documents of your choice, that should
                    appear in the reponse.
                  </li>
                </ul>
                <li>
                  Execute the workflow by calling the {tx("DDDI_Save")} API, which will
                  create the e-invoice using the provided invoice data, as well
                  as perform the chosen steps, return the desired documents and
                  save the invoice.
                </li>
              </ol>
              <p>
                By following these three steps, you can seamlessly integrate
                with the DDD Invoices service and leverage its functionalities
                for your invoice management needs.
              </p>
            </div>
            <div className="img-container text-center">
              <div style={{ position: "relative" }}>
                <img
                  src={SchemaImg}
                  alt="Schema showing the flow of the invoice"
                  class="img-fluid"
                  style={{ flex: 1 }}
                />
                <OverlayTrigger
                  placement="bottom"
                  overlay={tooltip}
                  key={`overlay-trigger`}
                  flip={false}
                  className={`btn btn-secondary img-tooltip ${classes["hint-btn"]}`}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="18"
                    fill="#155f85"
                    class="bi bi-info-circle"
                    viewBox="0 0 16 16"
                    style={{ position: "absolute", top: "51%", left: "15%" }}
                  >
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"></path>
                    <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"></path>
                  </svg>
                </OverlayTrigger>
                {/* <button
                  type="button"
                  class={`btn btn-secondary img-tooltip ${classes["hint-btn"]}`}
                  style={{ position: "absolute" }}
                  data-bs-toggle="tooltip"
                  data-bs-placement="bottom"
                  title={tx("Set up the steps that will be executed on the invoice data (generate PDF, fiscalization, generate e-invoice, send to domestic tax authority, send internationally etc.) and choose what documents you want to get in the response of the DDDI_Save API call (PDF, e-invoice, PEPPOL e-invoice etc.). For your domestic country's default settings, choose step 999.")}
                >
                 
                </button> */}
              </div>
            </div>
          </div>
          {/* <img src={SchemaImg} alt="" />
          <p>
            First, get an initialized invoice JSON object with metadata.
            Afterwards, add data to an invoice object and lastly send an invoice
            object to the service. If successful, through this quick and
            easy-to-use process, your invoice will become an e-invoice in the
            DDD Invoice service.
          </p> */}
          <p>
            In the DDD Invoices service, the e-invoice can be fiscalized,
            distributed to the tax authority (TA) portal, sent to the Peppol
            network, sent directly to the buyer or e-archived in a secure cloud.
            Once the e-invoice is saved, it can be viewed on the interactive
            e-invoices page.
          </p>
        </div>
    </>
  );
};

export default IntroFull;
